"use client";

import { clsx } from "clsx";
// TODO: migrate to react aria alternative
import { useControllableState } from "@radix-ui/react-use-controllable-state";

export function TextEditor({
  className,
  textClassName,
  value: controlledValue,
  defaultValue = "",
  onChange,
  children: render = text => text,
  ...textareaProps
}: {
  className?: string;
  textClassName?: string;
  value?: string;
  defaultValue?: string;
  onChange?: (value: string) => void;
  children?: (text: string) => React.ReactNode;
} & Pick<
  React.ComponentProps<"textarea">,
  "placeholder" | "spellCheck" | "aria-label" | "id" | "maxLength" | "disabled"
>) {
  const [value, setValue] = useControllableState({
    prop: controlledValue,
    defaultProp: defaultValue,
    onChange,
  });

  return (
    <div className={clsx("tw-relative", className)}>
      <div className={textClassName} style={{ whiteSpace: "pre-wrap", overflowWrap: "break-word" }} inert>
        {render(value)}
        {/* Add a zero-width space to the end of the text to prevent trailing line breaks from being collapsed */}
        {"​"}
      </div>
      <textarea
        value={value}
        onChange={e => {
          setValue(e.target.value);
        }}
        className={textClassName}
        style={{
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          overflow: "hidden",
          resize: "none",
          color: "transparent",
          backgroundColor: "transparent",
        }}
        {...textareaProps}
      />
    </div>
  );
}
